import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "image-gallery" };
const _hoisted_2 = { class: "header" };
const _hoisted_3 = { class: "actions" };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = { class: "image-grid" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["checked", "onClick"];
const _hoisted_8 = ["src", "alt", "onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "preview-header" };
const _hoisted_11 = { class: "preview-tip" };
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = { class: "preview-footer" };
const _hoisted_14 = { class: "image-info" };
const _hoisted_15 = {
    key: 0,
    class: "image-counter"
};
const _hoisted_16 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_17 = {
    key: 2,
    class: "loading-overlay"
};
const _hoisted_18 = {
    key: 3,
    class: "phone-modal"
};
const _hoisted_19 = { class: "phone-modal-content" };
const _hoisted_20 = { class: "phone-modal-header" };
const _hoisted_21 = { class: "phone-modal-body" };
const _hoisted_22 = { class: "input-group" };
const _hoisted_23 = { class: "input-group" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = { class: "modal-actions" };
const _hoisted_26 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    class: "btn-select-all",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                }, _toDisplayString(_ctx.isAllSelected ? '取消全选' : '全选'), 1),
                _createElementVNode("button", {
                    class: "btn-download",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.downloadSelected && _ctx.downloadSelected(...args))),
                    disabled: _ctx.selectedImages.length === 0
                }, " 下载 (" + _toDisplayString(_ctx.selectedImages.length) + ") ", 9, _hoisted_4)
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: image.id,
                    class: _normalizeClass(["image-item", { selected: _ctx.isSelected(image.id) }])
                }, [
                    _createElementVNode("div", {
                        class: "checkbox-wrapper",
                        onClick: _withModifiers(($event) => (_ctx.toggleSelect(image.id)), ["stop"])
                    }, [
                        _createElementVNode("input", {
                            type: "checkbox",
                            checked: _ctx.isSelected(image.id),
                            onClick: _withModifiers(($event) => (_ctx.toggleSelect(image.id)), ["stop"])
                        }, null, 8, _hoisted_7),
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "checkmark" }, null, -1))
                    ], 8, _hoisted_6),
                    _createElementVNode("img", {
                        src: image.url,
                        alt: image.name,
                        class: "image",
                        onClick: ($event) => (_ctx.previewImage(image)),
                        onError: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                    }, null, 40, _hoisted_8),
                    _createElementVNode("div", {
                        class: "image-name",
                        onClick: ($event) => (_ctx.toggleSelect(image.id))
                    }, _toDisplayString(image.name), 9, _hoisted_9)
                ], 2));
            }), 128))
        ]),
        (_ctx.previewVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "preview-modal",
                onClick: _cache[10] || (_cache[10] =
                    //@ts-ignore
                    (...args) => (_ctx.closePreview && _ctx.closePreview(...args)))
            }, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.isWechatBrowser ? '长按图片保存到相册' : '左右滑动切换图片'), 1),
                    _createElementVNode("button", {
                        class: "close-btn",
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.closePreview && _ctx.closePreview(...args)))
                    }, "×")
                ]),
                _createElementVNode("div", {
                    class: "preview-content",
                    onTouchstart: _cache[7] || (_cache[7] =
                        //@ts-ignore
                        (...args) => (_ctx.handleTouchStart && _ctx.handleTouchStart(...args))),
                    onTouchmove: _cache[8] || (_cache[8] =
                        //@ts-ignore
                        (...args) => (_ctx.handleTouchMove && _ctx.handleTouchMove(...args))),
                    onTouchend: _cache[9] || (_cache[9] =
                        //@ts-ignore
                        (...args) => (_ctx.handleTouchEnd && _ctx.handleTouchEnd(...args)))
                }, [
                    (_ctx.canGoPrev)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "nav-btn prev-btn",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.goToPrevImage && _ctx.goToPrevImage(...args)), ["stop"]))
                        }, " ‹ "))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "image-wrapper",
                        style: _normalizeStyle({ transform: `translateX(${_ctx.touchOffset}px)` })
                    }, [
                        _createElementVNode("img", {
                            src: _ctx.currentPreviewImage?.url,
                            alt: _ctx.currentPreviewImage?.name,
                            class: "preview-image",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(() => { }, ["stop"]))
                        }, null, 8, _hoisted_12)
                    ], 4),
                    (_ctx.canGoNext)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "nav-btn next-btn",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.goToNextImage && _ctx.goToNextImage(...args)), ["stop"]))
                        }, " › "))
                        : _createCommentVNode("", true)
                ], 32),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.currentPreviewImage?.name) + " ", 1),
                        (_ctx.selectedImages.length > 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (" + _toDisplayString(_ctx.currentImageIndex + 1) + "/" + _toDisplayString(_ctx.selectedImages.length) + ") ", 1))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.images.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("p", null, "暂无图片", -1)
                ]))]))
            : _createCommentVNode("", true),
        (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("div", { class: "spinner" }, null, -1),
                    _createElementVNode("p", null, "正在下载...", -1)
                ]))]))
            : _createCommentVNode("", true),
        (_ctx.showPhoneModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                        _cache[21] || (_cache[21] = _createElementVNode("h3", null, "手机号验证", -1)),
                        _createElementVNode("button", {
                            class: "close-btn",
                            onClick: _cache[11] || (_cache[11] =
                                //@ts-ignore
                                (...args) => (_ctx.closePhoneModal && _ctx.closePhoneModal(...args)))
                        }, "×")
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "modal-tip" }, "请输入手机号获取验证码", -1)),
                        _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.phoneNumber) = $event)),
                                type: "tel",
                                placeholder: "请输入手机号",
                                class: "phone-input",
                                maxlength: "11"
                            }, null, 512), [
                                [_vModelText, _ctx.phoneNumber]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.smsCode) = $event)),
                                type: "text",
                                placeholder: "请输入验证码",
                                class: "code-input",
                                maxlength: "6"
                            }, null, 512), [
                                [_vModelText, _ctx.smsCode]
                            ]),
                            _createElementVNode("button", {
                                class: "send-code-btn",
                                onClick: _cache[14] || (_cache[14] =
                                    //@ts-ignore
                                    (...args) => (_ctx.sendSmsCode && _ctx.sendSmsCode(...args))),
                                disabled: !_ctx.canSendCode || _ctx.isSendingCode
                            }, _toDisplayString(_ctx.sendCodeText), 9, _hoisted_24)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                                class: "cancel-btn",
                                onClick: _cache[15] || (_cache[15] =
                                    //@ts-ignore
                                    (...args) => (_ctx.closePhoneModal && _ctx.closePhoneModal(...args)))
                            }, "取消"),
                            _createElementVNode("button", {
                                class: "confirm-btn",
                                onClick: _cache[16] || (_cache[16] =
                                    //@ts-ignore
                                    (...args) => (_ctx.verifySmsCode && _ctx.verifySmsCode(...args))),
                                disabled: !_ctx.phoneNumber || !_ctx.smsCode || _ctx.isVerifying
                            }, _toDisplayString(_ctx.isVerifying ? '验证中...' : '确认'), 9, _hoisted_26)
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
